import axios from 'axios';

// Em desenvolvimento o pedido sai do mesmo endereço da página. O servidor do
// Create React App encaminha /transcription para 127.0.0.1:3001. Um endereço
// absoluto http://localhost:3001 falha no ngrok: a página é HTTPS de outra
// origem, e a API só aceita http://localhost:3000.
const transcriptionUrl = process.env.NODE_ENV === 'production'
  ? '/api/transcription'
  : '/transcription';

export const getTranscription = (data) => {
  return axios.post(transcriptionUrl, data, { headers: { Accept: 'application/json' } })
    .then(response => {
      if(!response?.data?.transcription?.length) throw new Error("getTranscription Error")
      return response.data.transcription
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

/*

import axios from 'axios';

const SERVER_URL = 'http://localhost:3001'; // mudar url

export const getTranscription = (data) => {
  return axios.post(`${SERVER_URL}/transcription`, data)
    .then(response => {
      if(!response?.data?.transcription?.length) throw new Error("getTranscription Error")
      return response.data.transcription
    })
    .catch(error => console.error('Error:', error));
}
    */